export default __webpack_public_path__ + "static/media/Aerosol.f034735c.gif";